import type { MerchantOrderType } from "@/types/reports";
import type { OfferPageTemplateResponse } from "@/types/offers";

export const getMerchantOrderingFromOfferPage = (
    offerPageTemplate?: OfferPageTemplateResponse | null
): MerchantOrderType[] => {
    const merchantOrderArray: MerchantOrderType[] = [];
    offerPageTemplate?.data?.attributes?.offers?.forEach((offer, index) => {
        const merchantName = offer?.attributes?.merchant?.data?.attributes.name;
        merchantOrderArray.push({
            merchant: merchantName || "",
            position: index + 1,
        });
    });

    const pageFeatures = offerPageTemplate?.data?.attributes?.PF;

    const adUnitOrderArray: MerchantOrderType[] = [];
    if (pageFeatures) {
        pageFeatures.forEach((feature) => {
            if ("ad_unit" in feature) {
                const adUnit = feature?.ad_unit?.data;
                if (adUnit) {
                    const merchantName =
                        adUnit?.attributes?.offer?.data?.attributes?.merchant
                            ?.data?.attributes?.name;
                    adUnitOrderArray.push({
                        merchant: merchantName || "",
                        position: feature.position || 0,
                        isAdUnit: true,
                    });
                }
            }
        });
    }
    return mergeMerchantOrderingAndAddPrefixes(
        merchantOrderArray,
        adUnitOrderArray
    );
};

const mergeMerchantOrderingAndAddPrefixes = (
    merchantList: MerchantOrderType[],
    pageFeaturesList: MerchantOrderType[]
): MerchantOrderType[] => {
    const mergedList = [...merchantList, ...pageFeaturesList].sort((a, b) => {
        if (a.position === b.position) {
            if (a.isAdUnit && b.isAdUnit) {
                return (
                    pageFeaturesList.indexOf(a) - pageFeaturesList.indexOf(b)
                );
            }
            return a.isAdUnit ? -1 : 1;
        }
        return a.position - b.position;
    });

    const reassignedList = mergedList.map((item, index) => ({
        ...item,
        position: index + 1,
    }));

    // If the merchant is from the "page features" list (i.e. it is an "ad unit"),
    // add 1000 to the index so we can differentiate between an ad unit and a normal offer
    // Initially we were going to prefix the index with `ad-` but this was not possible
    // without changing the type of the position field in BQ from INT to STRING
    // Prefixing the merchant name is the other option - but this may harm our ability
    // to calculate the performance of a particular merchant
    const merchantOrderWithAdjustedPositions: MerchantOrderType[] = [];
    reassignedList.forEach((item) => {
        merchantOrderWithAdjustedPositions.push({
            merchant: item.merchant,
            position: item.isAdUnit ? item.position + 1000 : item.position,
        });
    });

    return merchantOrderWithAdjustedPositions;
};
